export const COMMUNITY_ID = "communityId";
export const NAME = "vendorName";
export const CONTACT_NAME = "vendorContactName";
export const FEIN = "vendorFein";
export const PHONE_NO = "vendorPhone";
export const EMAIL_ID = "vendorEmail";
export const WEBSITE = "vendorWebsite";
export const ADDRESS_1 = "address1";
export const ADDRESS_2 = "address2";
export const CITY = "city";
export const STATE = "state";
export const ZIPCODE = "zip";
export const COUNTRY = "country";
export const PO_BOX = "po_box";
export const IS_ACTIVE = "active";
